/* istanbul ignore file */
import { Route, AppId, createPageRoute } from '@lumapps/router';

export const identityProviderRoute: Route = createPageRoute({
    slug: 'provider-settings/identity-providers',
    legacyId: 'app.admin.providers-idp',
    appId: AppId.backOffice,
});
